import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private sidebarVisibilitySubject = new BehaviorSubject<boolean>(false);

  get sidebarVisible(): Observable<boolean> {
    return this.sidebarVisibilitySubject.asObservable();
  }

  toggleSidebar(value: boolean): void {
    this.sidebarVisibilitySubject.next(value);
  }
}
